<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/Monitor Quiz</span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="loader" absolute>
			Loading
		    <v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
        <v-dialog v-if="dialog" v-model="dialog" hide-overlay persistent width="300">
            <v-card color="primary" dark >
            <v-card-text>Please Wait while Loading..
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
            </v-card>
        </v-dialog>
        <v-card class="card2">
            <div class="text-center heading">
                <v-row>
                    <v-col cols="12" sm="4">
                        <strong> Exam Name : {{examname}} </strong>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <strong> Course: {{coursename}} </strong>
                    </v-col>
                    <!--<v-col cols="12" sm="4">
                        <strong> Exam Weightage: {{weightage}} </strong>
                    </v-col>-->
                </v-row>
            </div>
            <div>
                <v-row>
                    <v-col cols="12">
                        <center>
                            <v-btn class="button" @click="copyQuestionFormQuestionBank()"> Copy from Your Question Bank</v-btn>
                            <v-btn class="button" @click="view_dialog()">View Template</v-btn>
                            <v-btn class="button" @click="allocateQuestion()" :disabled="!isschedule">Allocate Question To Student</v-btn>
                        </center>
                    </v-col>
                    <v-col cols="12">
                        <center>
                           <b>Template Status - </b><span v-if="isschedule" style="color:green;font-weight:600;font-size:20px;">Completed</span><span v-else style="color:red;font-weight:600;font-size:20px;">In-Complete</span>
                        </center>
                    </v-col>
                    <v-col cols="12">
                        <center>
                            Expected Questions : <span style="color:green;font-weight:400;font-size:16px;">{{expected_total_ques_as_per_template }}</span>
                        </center>    
                    </v-col>
                    <v-col cols="12">
                        <center>
                           Total Registered Student : <span style="color:green;font-weight:400;font-size:16px;">{{total_student}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                           Quiz Registered Student Count: <span style="color:green;font-weight:400;font-size:16px;">{{learner_exam_summary_count}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                           Allocation Count : <span style="color:green;font-weight:400;font-size:16px;">{{ allocation_done }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                           In-complete Allocation : <span style="color:green;font-weight:400;font-size:16px;">{{ incomplete_allocation }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                           No Allocation : <span style="color:green;font-weight:400;font-size:16px;">{{ no_allocation }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </center>
                    </v-col>
                    <v-col cols="12">
                        <center>
                           <b>Question Allocation Status -</b> <span v-if="allocationstatus" style="color:green;font-weight:600;font-size:20px;">Completed</span><span v-else style="color:red;font-weight:600;font-size:20px;">In-Complete</span>
                        </center>
                    </v-col>
                </v-row>
                <v-row v-if="copyquestioncliked">
                    <hr>
                    <hr>
                    <br>
                    <v-col cols="12">
                        <table style="width:100%">
                            <tr>
                                <td style="padding:10px;">
                                    <v-checkbox color="primary" class="checkboxsize" label="Select All" v-model="selectAll" name="myCheckbox" @change="selectall()" id="headerCheckbox" />
                                    <v-select label="Unit Number" :items="['All', 1, 2, 3, 4, 5,6,7,8,9,10]" v-model="filterunitnumber" style="width: 200px;" @update:modelValue="filterQuestionBasedOnUnitNumber"></v-select>
                                    <center><b>Question List</b></center>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="12" v-if="filterQuestionBasedOnUnitNumber.length">
                        <table style="width:100%">
                            <tr v-for="(item,index) in filterQuestionBasedOnUnitNumber" :key="index">
                                <td style="width:18%;">
                                    <table>
                                        <tr>
                                            <th colspan="2">
                                                <input type="checkbox" name="checkedValue"  class="check" v-model="item.check"/>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Unit No.</th>
                                            <td>{{item.unitnumber}}</td>
                                        </tr>
                                        <tr>
                                            <th>Question Type</th>
                                            <td>{{ item.que_type }} </td>
                                        </tr>
                                        <tr>
                                            <th>Difficulty Level</th>
                                            <td>{{ item.difficulty_level }} </td>
                                        </tr>
                                        
                                        <!--<tr>
                                            <th>Weightage </th>
                                            <td>{{ item.weightage }} </td>
                                        </tr>-->
                                    </table>
                                </td>
                                <td>
                                    Question Number : {{ index+1 }} <br><br>
                                    Question statement : <br>
                                    <div v-html="item.question_stmt"></div><br>
                                    <v-img  v-if="item.quefile != null" :src="item.quefile" style="width:auto;" ></v-img>
                                    <br>Options:<br>
                                    <br>
                                    <table>
                                        <tr v-for="(item2,index2) in item.option_list" :key="index2">
                                            <span v-if="item2.isoption_iscorrect == true">
                                                <td  style="background-color:limegreen;">{{item2.option_name}}</td>
                                                <td width="4%" style="background-color:limegreen;"><input type="radio" checked="true" disabled="true" style="height:1em; width:1em;"> </td>
                                                <td ><span class="span-mr" v-if="item2.option_value" v-html="item2.option_value"></span></td>
                                            </span>
                                            <span v-else>
                                                <td >{{ item2.option_name }}</td>
                                                <td width="4%"> <input type="radio" name="myGroup" disabled="true" style="height:1em; width:1em;"></td>
                                                <td ><span class="span-mr" v-if="item2.option_value" v-html="item2.option_value"></span></td>
                                            </span>
                                            <td  v-if="item2.answerfile != null">
                                                <v-img  :src="item2.answerfile" style="width:auto;" ></v-img>
                                            </td>
                                            
                                        </tr>
                                    </table>
                                    <br>
                                    CO Code : {{ item.co_code }}
                                </td>
                            </tr>
                        </table>
                        <br/>
                        <v-row justify="center" v-if="filterQuestionBasedOnUnitNumber.length">
                            <v-btn color="primary" dark  class="mb-2"  @click="copyQuizQuestionFromQuestionBank">
                                COPY
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="12" v-else>
                        <center v-if="copyquestioncliked" style="color:red;font-weight:600;">Question Not Found or All Question already present in Examination !!</center>
                    </v-col>
                </v-row>
            </div>
            <div v-if="question_list.length">
                <hr>
                <hr>
                <br>
                <center><b>Exam Questions</b></center>
                <v-col class="mx-auto" v-for=" (item,index) in question_list" :key="item[0].id">
                    <v-card class="box card-border" flat>
                        <template>
                            <div class="text-center">
                                <v-chip class="ma-2" color="success" outlined>
                                    Question Number {{ index + 1}}
                                </v-chip>
                                <v-chip class="ma-2" color="primary" outlined pill>
                                    Unit No {{ item[0].unit }}
                                </v-chip>
                                <v-chip class="ma-2" color="deep-purple accent-4" outlined>
                                    Difficulty Level : {{ item[0].difficulty }}
                                </v-chip>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" >
                                    <span class="text"> 
                                        <strong>Problem Statement:</strong>
                                    </span>
                                </v-col>
                            </v-row>
                            <v-col class="col">
                                <v-row v-model="question_stmt" class="span-mr" v-if="item[0].question_stmt" v-html="item[0].question_stmt"></v-row>
                                <span v-if="item[0].quefile">
                                    <img class="imgs" :src="item[0].quefile" />
                                </span>
                            </v-col>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" >
                                    <span class="text">
                                        <strong>Options:</strong>
                                    </span>
                                </v-col>
                            </v-row>
                            <v-col class="col" v-for="(option) in item[1]" :key="option.option_name">
                                <v-col>
                                    <v-row>
                                        <span class="span-mr"> {{option.option_name}}.</span>
                                        <input class="radiospace" type="radio" v-if="option.iscorrect" :checked="option.id"  />
                                        <input type="radio" name="opt" class="radiospace" v-else v-model="opt_id" v-bind:value="option.id" disabled />
                                        <span class="span-mr" v-if="option.option_value" v-html="option.option_value"></span>
                                    </v-row>
                                    <v-row>
                                        <span class="span-mr" v-if="option.answerfile">
                                            <img class="imgs" :src="option.answerfile" />
                                        </span>
                                    </v-row>
                                </v-col>
                            </v-col>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" >
                                    <span class="text"> 
                                        <strong>CO Code:</strong>{{item[0].co_code}}
                                    </span>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card>
                </v-col>
            </div>

            <v-dialog v-model="edit_dialog" persistent>
                <v-card> 
                    <v-card-title>Template Details</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row><b>Template Name : {{ quiztemplatename }}</b>
                        </v-row>
                        <v-row><b>Total Marks : {{ total_marks }}</b>
                        </v-row><br/><br/>
                        <table class="table table-bordered table-condensed">
                            <thead>
                                <tr style="background-color: #E8EAF6;">
                                    <th>Sr.No.</th>
                                    <th>Unit Number</th>
                                    <!--<th>Weightage</th>-->
                                    <th>Difficulty Level</th>
                                    <th>No. Of Questions Per Unit</th>
                                    <th>Minimum No. of <br>Questions to be entered<br> in Quiz</th>
                                    <th>Total No. Of Questions Added</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index1) in template_array" :key="index1" :style="{background:item.color}">
                                    <td>{{index1+1}}</td>
                                    <td>{{ item.unit_number }}</td>
                                    <!--<td>{{ item.weightage }} </td>-->
                                    <td>{{ item.level }} </td>
                                    <td>{{ item.numberofquestions }} </td>
                                    <td>{{ item.min_no_of_que }} </td>
                                    <td>{{ item.quesCount }} </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" variant="text" @click="edit_dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import loader from "sass-loader";
    import datetime from 'vuejs-datetimepicker'

    export default {
        components: {
            "vue-mathjax": VueMathjax,
            "datetime":datetime,
        },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                loader:false,
                dialog : false,
                isschedule : false,
                allocationstatus:false,
                question_list : [],
                questionBankAlreadyPresent: [],
                coursename: null,
                examname: null,
                weightage : 0,
                totalmarks: null,
                questioncount: null,
                examtimetableid : null,
                filterunitnumber:"All",
                copyquestioncliked :false,
                selectAll:true,
                opt_id: null,
                question_stmt: null,
                view_template:null,
                edit_dialog:false,
                template_array:[],
                total_marks:"",
                quiztemplatename:"",
                ques_in_bank:"",
                expected_total_ques_as_per_template:"",
                allocation_done:"",
                incomplete_allocation:"",
                no_allocation:"",
                total_student:"",
                learner_exam_summary_count:"",
            };
        },
        mounted() {
            this.examtimetableid = this.$route.params.examtimetableid;
            this.init();
        },
        methods: {
            init() {
                this.dialog = true;  
                const data = {
                    examtimetableid: this.examtimetableid,
                };
                axios
                    .post("QuizDashboard/fetchQuizQuestionPaper",data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.question_list = res.data.question_list;
                            this.coursename = res.data.coursename;
                            this.examname = res.data.examname;
                            this.weightage = res.data.weightage;
                            this.template_array = res.data.template_array;
                            this.quiztemplatename = res.data.quiztemplatename;
                            this.isschedule = res.data.isschedule;
                            this.total_marks = res.data.total_marks;
                            this.ques_in_bank = res.data.ques_in_bank;
                            this.expected_total_ques_as_per_template = res.data.expected_total_ques_as_per_template;
                            this.allocation_done = res.data.allocation_done;
                            this.incomplete_allocation = res.data.incomplete_allocation
                            this.no_allocation= res.data.no_allocation;
                            this.total_student = res.data.total_student;
                            this.allocationstatus = res.data.allocationstatus;
                            this.learner_exam_summary_count = res.data.learner_exam_summary_count;
                            this.dialog = false;
                            if (window.MathJax) {
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                            };
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },

            copyQuestionFormQuestionBank(){
                this.dialog = true;  
                this.copyquestioncliked = true;
                const data = {
                    examtimetableid: this.examtimetableid,
                };
                axios
                    .post("QuizDashboard/copyQuestionFormQuestionBank",data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.questionBankAlreadyPresent = res.data.questionBankAlreadyPresent;
                            this.dialog = false;
                            if (window.MathJax) {
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                            };
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            copyQuizQuestionFromQuestionBank() {
                this.dialog = true;  
                var checkBox = []
                for(var i in this.filterQuestionBasedOnUnitNumber){
                    if(this.filterQuestionBasedOnUnitNumber[i].check == true){
                        checkBox.push(this.filterQuestionBasedOnUnitNumber[i].que_id)
                    }
                }
                const data = {
                    examtimetableid: this.examtimetableid,
                    checkedValue:checkBox,
                };
            
                axios
                    .post("QuizDashboard/copyQuizQuestionFromQuestionBank",data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.showSnackbar("green", "Question Copied Successfully");
                            this.dialog=false;
                            this.init();
                            this.copyquestioncliked = false;
                        } else if(res.data.status == "201") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.dialog = false;  
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.dialog = false;  
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;  
                    });
            },
            allocateQuestion(){
                this.dialog = true;  
                const data = {
                    examtimetableid: this.examtimetableid,
                };
                axios
                    .post("QuizDashboard/allocateQuestionToStudent",data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.showSnackbar("green", "Question Allocated Successfully");
                            this.dialog=false;
                            this.init();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            selectall() {
                console.log("here");
                var checkBox=[]
                for(var i in this.filterQuestionBasedOnUnitNumber){
                    if(this.selectAll == true || this.selectAll == 'true'){
                        this.filterQuestionBasedOnUnitNumber[i].check = true;
                        checkBox.push(this.filterQuestionBasedOnUnitNumber[i].que_id)
                    }
                    else{
                        this.filterQuestionBasedOnUnitNumber[i].check = false
                    }
                }
            },
            view_dialog(value) {
                this.view_template = value;
                this.edit_dialog = !this.edit_dialog;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        computed:{
            filterQuestionBasedOnUnitNumber(){
                let filteredData = this.questionBankAlreadyPresent.filter((item) => {
                    if(this.filterunitnumber != 'All'){
                        return item.unitnumber == this.filterunitnumber
                    }else{
                        return item
                    }
                })
                if (window.MathJax) {
                    console.log("rendering mathjax");
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                };
                
                return filteredData
            }
        },
    };
</script>
<style scoped>
     .label-row {
        display: flex;
        justify-content: space-between;
        margin: 0 10px;
        /* Equal margin on left and right sides */
    }

    .label-col {
        flex: 1;
        margin: 10px;
    }

    .red--text {
        color: red;
    }

    .font-weight-bold {
        font-weight: bold;
    }
    thead {
        background-color: rgb(91, 91, 248) !important;
    }
    .button {
    border: 2px solid hsla(190, 99%, 30%, 1) !important;
    color: rgb(1, 127, 152);
    background: transparent !important;
    border-radius: 50px;
}
table {
    border-collapse: collapse;
    width: 100%;
  }
  
   td{
    border: 1px solid black;
    padding: 5px;
  }
   th {
    border: 1px solid black;
    padding: 5px;
  }
  

  .warning {
    background-color:#E8EAF6 !important;
  }
  .success{
    background-color:#E8EAF6 !important;
  }
  .danger{
    background-color:#E8EAF6 !important;
  }
</style>
